import React from "react"
import GalleryDetailPage from "../../features/pages/GalleryDetailPage"
import GalleryErrorPage from "../../features/pages/GalleryErrorPage"
import galleryApiService from "../../services/galleryApiService"

const GalleryDetail = ({ errorCode, galleryDetails, featuredGalleries }) => {
  if (errorCode && errorCode !== 200)
    return (
      <GalleryErrorPage
        status={errorCode}
        gallery={galleryDetails}
        featuredGalleries={featuredGalleries}
      />
    )

  return <GalleryDetailPage galleryDetails={galleryDetails} />
}

export const getServerSideProps = async ({ params, res }) => {
  const domain = params.id
  try {
    const response = await galleryApiService.galleryByDomain(domain)

    // If the gallery is not available, get the featured galleries
    let featuredGalleries = null
    if (response.data.status === 403) {
      try {
        const result = await galleryApiService.featured()
        featuredGalleries = result.data
      } catch (error) {
        console.error("Error fetching featured galleries:", error)
        featuredGalleries = []
      }
    }

    return {
      props: {
        errorCode: response.data.status,
        galleryDetails: {
          ...response.data,
          domain,
        },
        featuredGalleries: featuredGalleries,
      },
    }
  } catch (e) {
    return { notFound: true }
  }
}

export default GalleryDetail
